import React, {useRef} from 'react';
import {Button, Tag} from 'antd';
import {EditOutlined} from '@ant-design/icons';
import PdfLink from '../../components/PdfLink';
import {useNavigate} from 'react-router-dom';
import ENDPOINTS from '../../constants/endpoints';
import {formatPath, ROUTES} from '../../constants/PathRoutes';
import SearchTable from '../../components/admin/SearchTable';
import {dateFormat} from '../../utils/utils';

const STATUS_COLOR = {
    PENDING: 'orange',
    VALID: 'green',
    EXPIRED: 'red',
};

export default function AdminPrescriptionList() {
    const tableRef = useRef();
    const navigate = useNavigate();

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 60,
        },
        {
            title: 'Cliente',
            dataIndex: 'client_name',
            key: 'client_name',
        },
        {
            title: 'Dependente',
            dataIndex: 'dependent_name',
            key: 'dependent_name',
            render: (name) => name || '-',
        },
        {
            title: 'Arquivo',
            dataIndex: 'prescription_file',
            key: 'prescription_file',
            render: (url) => <PdfLink url={url}/>,
        },
        {
            title: 'Desconto',
            dataIndex: 'discount_value',
            key: 'discount_value',
            render: (value) => (value ? `R$ ${Number(value).toFixed(2)}` : '-'),
        },
        {
            title: 'Validade',
            dataIndex: 'expiration_date',
            key: 'expiration_date',
            render: (date) => dateFormat(date) || '-',
        },
        {
            title: 'Status',
            dataIndex: 'status_display',
            key: 'status',
            render: (statusDisplay, record) => (
                <Tag color={STATUS_COLOR[record.status] ?? 'default'}>
                    {statusDisplay ?? '-'}
                </Tag>
            ),
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 80,
            render: (_, record) => (
                <Button
                    size="small"
                    icon={<EditOutlined/>}
                    onClick={() =>
                        navigate(formatPath(ROUTES.ADMIN_ECOMMERCE_PRESCRIPTION_DETAIL, {id: record.id}))
                    }
                />
            ),
        },
    ];

    return (
        <SearchTable
            ref={tableRef}
            url={ENDPOINTS.ECOMMERCE_STAFF_PRESCRIPTION_LIST}
            params={{status: 'PENDING'}}
            columns={columns}
            title="Prescrições Pendentes"
            showSearch={false}
        />
    );
}